import _ from 'underscore';

import {assert} from 'Asserts';
import * as benchlingUtil from 'BenchlingUtil';
import ProteinConstants from 'molbio/proteins/util/ProteinConstants';

import areAminoAcidsValid from './areAminoAcidsValid';

// Constants from:
// https://github.com/biojava/biojava/blob/02952752ada4ddc0e03ce8a4eea4d78d74192aef/biojava-aa-prop/src/main/java/org/biojava/nbio/aaproperties/Constraints.java
const INSTABILITY_MATRIX_AA_KEYS = [
  'W',
  'C',
  'M',
  'H',
  'Y',
  'F',
  'Q',
  'N',
  'I',
  'R',
  'D',
  'P',
  'T',
  'K',
  'E',
  'V',
  'S',
  'G',
  'A',
  'L',
];
// Keep in sync with INSTABILITY_INDEX_VALUES in benchling/pybio/proteins/constants.py
const INSTABILITY_MATRIX = [
  // W   C   M   H   Y   F   Q   N   I   R   D   P   T   K   E   V   S   G   A   L
  [
    1.0, 1.0, 24.68, 24.68, 1.0, 1.0, 1.0, 13.34, 1.0, 1.0, 1.0, 1.0, -14.03, 1.0, 1.0, -7.49, 1.0, -9.37,
    -14.03, 13.34,
  ],
  [
    24.68, 1.0, 33.6, 33.6, 1.0, 1.0, -6.54, 1.0, 1.0, 1.0, 20.26, 20.26, 33.6, 1.0, 1.0, -6.54, 1.0, 1.0,
    1.0, 20.26,
  ],
  [
    1.0, 1.0, -1.88, 58.28, 24.68, 1.0, -6.54, 1.0, 1.0, -6.54, 1.0, 44.94, -1.88, 1.0, 1.0, 1.0, 44.94, 1.0,
    13.34, 1.0,
  ],
  [
    -1.88, 1.0, 1.0, 1.0, 44.94, -9.37, 1.0, 24.68, 44.94, 1.0, 1.0, -1.88, -6.54, 24.68, 1.0, 1.0, 1.0,
    -9.37, 1.0, 1.0,
  ],
  [
    -9.37, 1.0, 44.94, 13.34, 13.34, 1.0, 1.0, 1.0, 1.0, -15.91, 24.68, 13.34, -7.49, 1.0, -6.54, 1.0, 1.0,
    -7.49, 24.68, 1.0,
  ],
  [
    1.0, 1.0, 1.0, 1.0, 33.6, 1.0, 1.0, 1.0, 1.0, 1.0, 13.34, 20.26, 1.0, -14.03, 1.0, 1.0, 1.0, 1.0, 1.0,
    1.0,
  ],
  [
    1.0, -6.54, 1.0, 1.0, -6.54, -6.54, 20.26, 1.0, 1.0, 1.0, 20.26, 20.26, 1.0, 1.0, 20.26, -6.54, 44.94,
    1.0, 1.0, 1.0,
  ],
  [
    -9.37, -1.88, 1.0, 1.0, 1.0, -14.03, -6.54, 1.0, 44.94, 1.0, 1.0, -1.88, -7.49, 24.68, 1.0, 1.0, 1.0,
    -14.03, 1.0, 1.0,
  ],
  [
    1.0, 1.0, 1.0, 13.34, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, -1.88, 1.0, -7.49, 44.94, -7.49, 1.0, 1.0, 1.0,
    20.26,
  ],
  [
    58.28, 1.0, 1.0, 20.26, -6.54, 1.0, 20.26, 13.34, 1.0, 58.28, 1.0, 20.26, 1.0, 1.0, 1.0, 1.0, 44.94,
    -7.49, 1.0, 1.0,
  ],
  [
    1.0, 1.0, 1.0, 1.0, 1.0, -6.54, 1.0, 1.0, 1.0, -6.54, 1.0, 1.0, -14.03, -7.49, 1.0, 1.0, 20.26, 1.0, 1.0,
    1.0,
  ],
  [
    -1.88, -6.54, -6.54, 1.0, 1.0, 20.26, 20.26, 1.0, 1.0, -6.54, -6.54, 20.26, 1.0, 1.0, 18.38, 20.26, 20.26,
    1.0, 20.26, 1.0,
  ],
  [
    -14.03, 1.0, 1.0, 1.0, 1.0, 13.34, -6.54, -14.03, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 20.26, 1.0, 1.0, -7.49,
    1.0, 1.0,
  ],
  [
    1.0, 1.0, 33.6, 1.0, 1.0, 1.0, 24.68, 1.0, -7.49, 33.6, 1.0, -6.54, 1.0, 1.0, 1.0, -7.49, 1.0, -7.49, 1.0,
    -7.49,
  ],
  [
    -14.03, 44.94, 1.0, -6.54, 1.0, 1.0, 20.26, 1.0, 20.26, 1.0, 20.26, 20.26, 1.0, 1.0, 33.6, 1.0, 20.26,
    1.0, 1.0, 1.0,
  ],
  [
    1.0, 1.0, 1.0, 1.0, -6.54, 1.0, 1.0, 1.0, 1.0, 1.0, -14.03, 20.26, -7.49, -1.88, 1.0, 1.0, 1.0, -7.49,
    1.0, 1.0,
  ],
  [
    1.0, 33.6, 1.0, 1.0, 1.0, 1.0, 20.26, 1.0, 1.0, 20.26, 1.0, 44.94, 1.0, 1.0, 20.26, 1.0, 20.26, 1.0, 1.0,
    1.0,
  ],
  [
    13.34, 1.0, 1.0, 1.0, -7.49, 1.0, 1.0, -7.49, -7.49, 1.0, 1.0, 1.0, -7.49, -7.49, -6.54, 1.0, 1.0, 13.34,
    -7.49, 1.0,
  ],
  [
    1.0, 44.94, 1.0, -7.49, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, -7.49, 20.26, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0,
    1.0,
  ],
  [
    24.68, 1.0, 1.0, 1.0, 1.0, 1.0, 33.6, 1.0, 1.0, 20.26, 1.0, 20.26, 1.0, -7.49, 1.0, 1.0, 1.0, 1.0, 1.0,
    1.0,
  ],
];

function getDipeptidesFromAminoAcids(aminoAcids: string): Array<string> {
  // `dipeptides` is a list of all pairs of adjacent amino acids
  const dipeptides = _.zip(aminoAcids.slice(0, aminoAcids.length - 1), aminoAcids.slice(1));
  // Ignore non-standard AAs since the literature doesn't have measured instability vals for these AAs
  return dipeptides.filter(
    (dipeptide) =>
      ProteinConstants.STANDARD_AMINO_ACIDS.indexOf(dipeptide[0]) !== -1 &&
      ProteinConstants.STANDARD_AMINO_ACIDS.indexOf(dipeptide[1]) !== -1
  );
}

function getInstabilityIndexOfDipeptide(dipeptide: string): number {
  const firstAAInstabilityIndex = INSTABILITY_MATRIX_AA_KEYS.indexOf(dipeptide[0]);
  const secondAAInstabilityIndex = INSTABILITY_MATRIX_AA_KEYS.indexOf(dipeptide[1]);
  return INSTABILITY_MATRIX[firstAAInstabilityIndex][secondAAInstabilityIndex];
}

// Logic from:
// https://github.com/biojava/biojava/blob/master/biojava-aa-prop/src/main/java/org/biojava/nbio/aaproperties/PeptidePropertiesImpl.java#L222
// Keep in sync with instability_index in benchling/pybio/proteins/protein_properties.py.
function getInstabilityIndex(aminoAcids: string): number {
  const upperAminoAcids = aminoAcids.toUpperCase();
  assert(areAminoAcidsValid(upperAminoAcids), 'Instability index requires valid amino acids.');

  if (upperAminoAcids.length < 2) {
    return 0.0;
  }

  // eslint-disable-next-line no-restricted-syntax
  const numAminoAcidsWithInstabilityVals = _.filter(
    upperAminoAcids,
    (aminoAcid) => ProteinConstants.STANDARD_AMINO_ACIDS.indexOf(aminoAcid) !== -1
  ).length;
  if (numAminoAcidsWithInstabilityVals === 0) {
    return 0.0;
  }

  const dipeptides = getDipeptidesFromAminoAcids(upperAminoAcids);
  const sum = benchlingUtil.sum(dipeptides, (dipeptide: string) => getInstabilityIndexOfDipeptide(dipeptide));
  return (sum * 10.0) / numAminoAcidsWithInstabilityVals;
}

export default getInstabilityIndex;
